import { useEffect } from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import * as Sentry from '@sentry/react';

export const SentryUserIntegration = () => {
  const { user, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (isAuthenticated && user) {
      Sentry.setUser({
        id: user.sub,
      });

      Sentry.setContext('auth0', {
        auth0UserId: user.sub,
        authProvider: typeof user.sub === 'string' ? user.sub.split('|')[0] : undefined,
        customerGroupType: user['https://idm.sky.co.nz/customer_group_type'],
      });
    } else {
      Sentry.setUser(null);
      Sentry.setContext('auth0', null);
    }
  }, [isAuthenticated, user]);

  return null;
};
